'use client'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { MicrosoftLogo } from '@repo/ui/MicrosoftLogo'
import { useEffect } from 'react'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useEmailStore } from '@repo/store/useEmailStore'
import { useNavigate } from 'react-router-dom'
import { useState, useCallback } from 'react'
import { useUrlStore } from '@repo/store/useUrlStore'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

const Email = () => {
  const { queryParams } = useUrlStore()
  const { createEmailSubscriptions, fetchHasEmailSubscription, deleteEmailSubscriptions } = useEmailStore()
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  const deleteEmailSubscriptionsIfNeeded = useCallback(async () => {
    const hasEmailSubscription = await fetchHasEmailSubscription()
    if (hasEmailSubscription !== true && hasEmailSubscription !== 'true') return

    await deleteEmailSubscriptions()
  }, [fetchHasEmailSubscription, deleteEmailSubscriptions])

  useEffect(() => {
    const handleEmailSetup = async () => {
      if (queryParams?.success === true || queryParams?.success === 'true') {
        setSuccess(true)
        setMessage(
          'Your email integration has been set up successfully! From now on, emails you send through Osprey will be sent from your Microsoft account.'
        )

        console.log('deleting email subscriptions')
        await deleteEmailSubscriptionsIfNeeded()

        console.log('creating email subscriptions')
        await createEmailSubscriptions()

        // this will update the values of hasGraphApiSubscriptions and hasGraphApiTokens in the store
        await useAuthenticationStore.getState().getProfile()
        await useAuthenticationStore.getState().fetchEmailSubscriptionEmailAddressByCurrentUser()
      } else {
        setMessage('There was an error setting up your email integration. Please try again.')
      }
    }

    handleEmailSetup()
  }, [queryParams, createEmailSubscriptions, deleteEmailSubscriptionsIfNeeded])

  const handleClickToTrayAgain = () => {
    navigate('/configuration/microsoft/email-setup')
  }

  return (
    <MUIStack
      data-testid="Email"
      gap={6}
      sx={{ maxWidth: 680, margin: 'auto', backgroundColor: 'white', borderRadius: '6px', padding: '60px 40px' }}
    >
      <MicrosoftLogo sx={{ width: '220px', height: 'auto', marginBottom: 3 }} />
      <MUITypography variant="body1">{message}</MUITypography>

      {!success ? (
        <MUIButton
          variant="contained"
          color="primary"
          size="large"
          onClick={handleClickToTrayAgain}
          sx={{ maxWidth: 160, width: '100%', margin: '20px 0 0 auto' }}
        >
          <ChevronRightIcon sx={{ color: 'white', transform: 'rotate(180deg)' }} />
          Back
        </MUIButton>
      ) : null}
    </MUIStack>
  )
}

export default Email
